import React, { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import Button, { ButtonVariant } from '@/components/button';
import Typography from '@/components/typography';

interface NavLinkTabProps {
  isActive: boolean;
  className?: string;
  onClick: () => void;
  label?: string | ReactNode;
  disabled?: boolean;
}

const NavLinkTab: FC<NavLinkTabProps> = ({
  isActive,
  className = undefined,
  onClick,
  label = '',
  disabled = false,
}) => {
  return (
    <Button
      className={twMerge(
        'group relative flex h-full w-full items-center justify-center px-6 py-3.5 text-gray-70 dark:text-gray-20',
        'hover:bg-gray-10 hover:text-gray-100',
        isActive && 'text-gray-100',
        className
      )}
      disabled={disabled}
      role="tab"
      variant={ButtonVariant.GHOST}
      onClick={onClick}
    >
      <Typography variant={isActive ? 'h6' : 'body2'}>{label}</Typography>

      {/* floating bottom border to avoid text shifts */}
      <div
        className={twMerge(
          'absolute bottom-0 left-0 h-[1px] w-full bg-gray-20 transition-all duration-200 group-hover:h-[2px] dark:border-gray-70',
          isActive && 'h-[2px] bg-green-50 dark:bg-green-40'
        )}
      />
    </Button>
  );
};

export default NavLinkTab;
